/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopCapacityScopeRequestSchema = z.object({
  roleIds: z.array(z.int()),
  skillIds: z.array(z.int()),
});
